class OurPricing {
  constructor() {
    this.init();
  }

  init() {
    this.handleMEWS();
  }

  handleMEWS() {
    const buttonSend = document.querySelector('#action-button-meet');
    buttonSend?.addEventListener('click', () => {
      this.openWidget(backendData.tokenMeet);
    });
  }

  openWidget(token){
    Mews.Distributor(
        {
          configurationIds: [token],
        },
        function (api) {
          api.open();
      }
    );
  }
}

new OurPricing();